export const styles = {
	ContentContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
	},
	CreateDisabledButtonBox: {
		display: { xs: 'none', sm: 'flex' },
		alignItems: 'center',
		justifyContent: 'flex-end',
		width: '100%',
		gap: '16px',
	},
	CreateButtonBox: {
		display: { xs: 'none', sm: 'contents' },
		justifyContent: 'flex-end',
		width: '100%',
		gap: '16px',
	},
	CreateButton: {
		borderColor: 'rgba(25, 118, 210, 0.5)',
		color: '#45657B',
		'&:hover': {
			borderColor: 'rgba(25, 118, 210, 0.5)',
			backgroundColor: 'rgba(25, 118, 210, 0.04)',
		},
		display: 'flex',
		boxSizing: 'content-box',
	},
	CustomGamesSupportLink: {
		color: '#45657b',
		textDecorationColor: '#45657b',
	},
	CustomGamesSupportText: {
		marginRight: { xs: '0rem', sm: '3rem' },
	},
	CreateButtonTextBox: {
		flex: { sm: '1 0 60%', md: '1 0' },
	},
	FilterRowGrid: {
		pb: 2,
		pt: 4,
		width: '100%',
		justifyContent: { sm: 'space-between', md: 'flex-end' },
		alignItems: 'center',
	},
	MobileCreateDisabledBox: {
		marginBottom: { xs: '0rem', sm: '2rem' },
		width: { sm: '100%', md: 'auto' },
	},
	MobileCreateButtonBox: {
		display: { xs: 'flow', sm: 'none' },
		alignItems: 'center',
		justifyContent: 'space-evenly',
		width: '100%',
		marginBottom: '2rem',
	},
	MobileCreateButtonDisabledBox: {
		display: { xs: 'flow', sm: 'none' },
		alignItems: 'center',
		justifyContent: 'space-evenly',
		width: '100%',
	},
	MobileCreateButton: {
		textAlign: 'center',
		marginBottom: '2rem',
		display: 'grid',
	},
	MobileSupportTextDisabled: {
		textAlign: 'center',
		marginBottom: '2rem',
	},
}
